import { Navigate, useLocation } from "react-router-dom";

export default function RelatoriosRedirect({ tab }) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  params.set("tab", tab);
  return <Navigate to={`/relatorios?${params.toString()}`} replace />;
}
